import React from 'react';

import AantalHonderdjarigen from './visualizations/aantal-honderdjarigen.js';
import AchtergrondStelselwetten from './visualizations/achtergrond-stelselwetten.js';
import AndereSpelers from './visualizations/andere-spelers.js';
import ChronischeZiekte from './visualizations/chronische-ziekte.js';
import EurosVWS from './visualizations/euros-vws.js';
import EurosCBS from './visualizations/euros-cbs.js';
import EurosVolwassene from './visualizations/euros-volwassene.js';
import GeldstromenJeugdwet from './visualizations/geldstromen-jeugdwet.js';
import GeldstromenWLZ from './visualizations/geldstromen-wlz.js';
import GeldstromenWMO from './visualizations/geldstromen-wmo.js';
import GeldstromenWPG from './visualizations/geldstromen-wpg.js';
import GeldstromenZiekenhuis from './visualizations/geldstromen-ziekenhuis.js';
import GeldstromenZVW from './visualizations/geldstromen-zvw.js';
import GezondeLevensverwachting from './visualizations/gezonde-levensverwachting.js';
import Hoofdrolspelers from './visualizations/hoofdrolspelers.js';
import LevensVerwachting from './visualizations/levensverwachting.js';
import LevensVerwachtingRegio from './visualizations/levensverwachting-regio.js';
import MarktenCuratieveZorg from './visualizations/markten-curatieve-zorg.js';
import Sectoren from './visualizations/sectoren.js';
import Werknemers from './visualizations/werknemers.js';
import ZiekenhuizenKlinieken from './visualizations/ziekenhuizen-klinieken.js';
import Zorginkoper from './visualizations/zorginkoper.js';

const vissen = {
	aantal_honderdjarigen: <AantalHonderdjarigen />,
	achtergrond_stelselwetten: <AchtergrondStelselwetten />,
	andere_spelers: <AndereSpelers />,
	chronische_ziekte: <ChronischeZiekte />,
	euros_vws: <EurosVWS />,
	euros_cbs: <EurosCBS />,
	euros_volwassene: <EurosVolwassene />,
	geldstromen_jeugdwet: <GeldstromenJeugdwet />,
	geldstromen_wlz: <GeldstromenWLZ />,
	geldstromen_wmo: <GeldstromenWMO />,
	geldstromen_wpg: <GeldstromenWPG />,
	geldstromen_ziekenhuis: <GeldstromenZiekenhuis />,
	geldstromen_zvw: <GeldstromenZVW />,
	gezonde_levensverwachting: <GezondeLevensverwachting />,
	hoofdrolspelers: <Hoofdrolspelers />,
	levensverwachting: <LevensVerwachting />,
	levensverwachting_regio: <LevensVerwachtingRegio />,
	markten_curatieve_zorg: <MarktenCuratieveZorg />,
	sectoren: <Sectoren />,
	werknemers: <Werknemers />,
	ziekenhuizen_klinieken: <ZiekenhuizenKlinieken />,
	zorginkoper: <Zorginkoper />,
};

export default vissen;
